export const DESTINATION_FALLBACK_IMAGES = Object.freeze([
  "/images/trail-default/trail-default-01.png",
  "/images/trail-default/trail-default-02.png",
  "/images/trail-default/trail-default-03.png",
  "/images/trail-default/trail-default-04.png",
]);

const stableHash = (value = "") => {
  let hash = 2166136261;
  for (const char of String(value)) {
    hash ^= char.charCodeAt(0);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
};

export const destinationFallbackImage = (destination = {}) => {
  const key = destination.id || destination.slug || destination.name || "bikepark-finder";
  return DESTINATION_FALLBACK_IMAGES[stableHash(key) % DESTINATION_FALLBACK_IMAGES.length];
};

export const destinationCoverImage = (destination = {}, preferredImage) => (
  preferredImage || destination.image || destinationFallbackImage(destination)
);
